import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { api, errMsg, timeAgo } from "@/lib/api";
import { Empty, ScriptureRef } from "./Common";

export function NotesPanel() {
  const [notes, setNotes] = useState<any[]>([]);
  const [f, setF] = useState({ ref: "", content: "" });
  const load = () => api.get("/notes").then((r) => setNotes(r.data));
  useEffect(() => { load(); }, []);
  const add = async () => {
    try { await api.post("/notes", { ...f, source: "Study log" }); setF({ ref: "", content: "" }); load(); toast.success("Note saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (id: string) => { await api.delete(`/notes/${id}`); load(); };
  return (
    <div className="grid gap-8 lg:grid-cols-12">
      <div className="card-warm h-fit space-y-3 p-6 lg:col-span-4">
        <h3 className="font-display text-2xl font-semibold">New note</h3>
        <Input data-testid="note-ref-input" value={f.ref} onChange={(e) => setF({ ...f, ref: e.target.value })} placeholder="Scripture reference (optional), e.g. Psalm 23:1" className="bg-white" />
        <Textarea data-testid="note-content-input" value={f.content} onChange={(e) => setF({ ...f, content: e.target.value })} placeholder="What stood out to you?" className="min-h-[140px] bg-white" />
        <Button data-testid="note-save-button" disabled={!f.content.trim()} onClick={add} className="w-full rounded-full bg-[#1E293B]">Save note</Button>
      </div>
      <div className="space-y-4 lg:col-span-8" data-testid="notes-list">
        {notes.length === 0 ? <Empty title="Your study log is empty" body="Notes from stories, studies, and reflections collect here." /> : notes.map((n) => (
          <div key={n.id} className="card-warm p-5" data-testid={`note-${n.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex flex-wrap items-center gap-2">{n.ref && <ScriptureRef refText={n.ref} />}<span className="text-xs text-slate-500">{n.source} · {timeAgo(n.created_at)}</span></div>
              <Button variant="ghost" size="icon" data-testid={`note-delete-${n.id}`} onClick={() => del(n.id)}><Trash2 className="h-4 w-4" /></Button>
            </div>
            <p className="mt-3 whitespace-pre-wrap text-slate-800">{n.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
